import React from "react";
import _ from "lodash";

import Button from "../base/Button";
import Glyphicon from "../base/Glyphicon";
import InputControl from "../base/InputControl";
import { ERROR } from "../../constants/AppColors";
import { toUnicode } from "../../utils/DomainUtils";

import ErrorUtils from "../../utils/ErrorUtils";

class AddRedirectForm extends React.Component {
  constructor(props) {
    super(props);

    this._onAdd = this._onAdd.bind(this);
    this._handleInputChange = this._handleInputChange.bind(this);
  }

  _onAdd() {
    let { form } = this.props;

    if (_.isEmpty(form.get("fromURL", ""))) {
      this.fromURLInput.focus();
    } else if (_.isEmpty(form.get("toURL", ""))) {
      this.toURLInput.focus();
    } else {
      if (this.props.onSubmit) {
        this.props.onSubmit();
      }
    }
  }

  _handleInputChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    if (this.props.onUpdate) {
      this.props.onUpdate({
        [name]: value,
      });
    }
  }

  _getErrorView(error) {
    let message = ErrorUtils.getFormattedError(error.toJS()).message;

    return <div style={{ color: ERROR, paddingTop: 6, textAlign: "center" }}>{message}</div>;
  }

  render() {
    let { domainName, form } = this.props;

    const isSaving = form.get("saving");
    const error = form.get("error");

    let errorView = null;

    if (error) {
      errorView = this._getErrorView(error);
    }

    return (
      <div style={{ padding: "12px" }}>
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ paddingRight: 6, maxWidth: 380, wordWrap: "break-word" }}>
            https://{toUnicode(domainName || "")}/
          </div>
          <div style={{ display: "flex", alignItems: "center", width: "50%" }}>
            <InputControl
              style={{ width: "100%" }}
              ref={(fromURL) => {
                this.fromURLInput = fromURL;
              }}
              name="fromURL"
              value={form.get("fromURL")}
              onChange={this._handleInputChange}
            />
          </div>
          <div style={{ padding: "0px 6px" }}>
            <Glyphicon glyph="right_arrow" />
          </div>
          <div style={{ display: "flex", alignItems: "center", width: "50%" }}>
            <InputControl
              style={{ width: "100%" }}
              ref={(toURL) => {
                this.toURLInput = toURL;
              }}
              name="toURL"
              value={form.get("toURL")}
              onChange={this._handleInputChange}
            />
          </div>
          <div style={{ width: "12%", paddingLeft: 6, display: "flex" }}>
            <Button look="primary" onClick={this._onAdd} disabled={isSaving}>
              Add
            </Button>
          </div>
        </div>
        {errorView}
      </div>
    );
  }
}

export default AddRedirectForm;
